import { render, staticRenderFns } from "./RightTabs.vue?vue&type=template&id=c2f96a4e&scoped=true&"
import script from "./RightTabs.vue?vue&type=script&lang=js&"
export * from "./RightTabs.vue?vue&type=script&lang=js&"
import style0 from "./RightTabs.vue?vue&type=style&index=0&id=c2f96a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f96a4e",
  null
  
)

export default component.exports